import React, { useCallback } from 'react'

import { ClockDefault, Icon, Modal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function PauseConfirmationModal({
  isOpen,
  onDone,
  pauseDate = null,
  locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(
      `subscription_management.pause_confirmation.${key}`,
      { ns: 'rails', lng: locale, ...options }
    ),
    [locale]
  )

  const description = pauseDate
    ? translate('description', { date: pauseDate })
    : translate('description_no_date')

  return (
    <Modal
      isOpen={isOpen}
      onClose={onDone}
      header={translate('header')}
      width="small"
      canClose
      customClass="pause-confirmation-modal"
      primaryAction={{
        content: translate('done_button'),
        buttonProps: { type: 'primary', onClick: onDone },
      }}
    >
      <div className="pause-confirmation-modal__body">
        <div className="pause-confirmation-modal__icon">
          <Icon svgComponent={ClockDefault} size="large" color="dark" />
        </div>
        <h4 className="pause-confirmation-modal__title">{translate('title')}</h4>
        <p className="cgt-text-medium pause-confirmation-modal__description">{description}</p>
      </div>
    </Modal>
  )
}

PauseConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  onDone: func.isRequired,
  pauseDate: string,
  locale: string,
}

export default PauseConfirmationModal
